<template>
  <div class="vld-parent">
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div
        class="container-fluid align-items-center vld-parent"
        ref="partners_container"
      >
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white my-3">
              Aqui você pode conferir todos os benefícios de aceleração
              cadastrados no portal. Todo novo benefício inserido aparecerá
              automaticamente na listagem abaixo.
            </p>
          </div>
        </div>
      </div>
      <div class="row"></div>
    </base-header>
    <div class="container-fluid mt--7">
      <div v-if="control.empty" class="row">
        <div class="col-12 mb-1 text-center">
          <badge type="info" class="bg-white">
            Não existem empresas associadas até o momento
          </badge>
        </div>
      </div>
      <div class="row text-center mt-2">
        <div class="col-12 mb-5">
          <base-button
            :custom="true"
            size="sm"
            type="primary"
            @click="$router.push('/admin/beneficios-aceleradas/novo')"
            ><i class="fas fa-plus mr-1"></i> Cadastrar nova
            parceria</base-button
          >
        </div>
      </div>
      <div v-if="!control.empty">
        <div class="row">
          <div class="col-12">
            <div class="card-deck">
              <div
                class="col-lg-4 col-md-6 mb-5 d-flex align-items-stretch"
                v-for="partner in partners"
                :key="partner.id"
              >
                <div class="card text-center flex-grow-1">
                  <div class="card-profile-image">
                    <img
                      :src="partner.image_url"
                      class="card-image my-3"
                      alt="..."
                    />
                  </div>
                  <div class="card-body mt-8 pt-0 pb-3">
                    <h2 class="mb-2 card-title text-orange">
                      {{ partner.name }}
                    </h2>
                    <div>
                      <p class="description font-weight-bold mt-1 mb-2">
                        <badge
                          :type="
                            partner.status === 'public' ? 'success' : 'warning'
                          "
                          title="`Status:`"
                          >{{
                            partner.status === "public" ? "Visível" : "Oculto"
                          }}</badge
                        >
                      </p>
                      <p class="description mb-0">
                        Categoria: {{ partner.category }}
                      </p>
                    </div>
                  </div>
                  <div class="card-footer text-center">
                    <router-link
                      :to="
                        '/admin/beneficios-aceleradas/' + partner.id + '/editar'
                      "
                      class="btn btn-white py-1 px-2"
                      title="'Editar parceria'"
                      ><i class="fas fa-edit text-info"></i
                    ></router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 mb-3 text-right">
            <p class="text-muted">
              Exibindo
              <span class="font-weight-bold">{{ partners.length }}</span> de um
              total de
              <span class="font-weight-bold">{{ control.total }}</span>
              parcerias.
            </p>
          </div>
          <div class="col-lg-12">
            <base-pagination
              :pageCount="control.lastPage"
              :perPage="control.limit"
              :value="control.page"
              size="md"
              align="center"
              @input="handlePageInput"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  data() {
    return {
      partners: [],
      control: {
        page: 1,
        limit: 10,
        lastPage: 0,
        total: 0,
        empty: "",
      },
    };
  },
  async mounted() {
    await this.loadPartners(this.control.page);
  },
  methods: {
    async loadPartners(page) {
      const loader = this.$loading.show({
        container: this.$refs.partners_container,
        width: 150,
        height: 150,
        opacity: 0,
      });
      try {
        const { data: partners } = await api.get(
          `/adm/partners?page=${page}&limit=${this.control.limit}`
        );
        this.control.lastPage = partners.lastPage;
        this.control.total = partners.total;
        this.control.page = partners.page;
        partners.data.forEach((partner) => {
          if (!partner.image_url)
            partner.image_url = "/img/pages/default_logo.png";
        });
        this.partners = partners.data;
        this.control.empty = partners.total <= 0;
        loader.hide();
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao recuperar as parcerias");
      }
    },
    async handlePageInput(page) {
      await this.loadPartners(page);
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 150px;
  height: 150px;
  border-radius: 10%;
  margin: auto;
}
</style>
